<div class="table-container" style="overflow:hidden; position: relative">
  <table class="table-header">
    <colgroup>
      <col width="5%"/>
      <col width="25%"/>
      <col width="40%"/>
      <col width="10%"/>
      <col width="5%"/>
    </colgroup>
    <thead>
      <tr>
        <th>
          <mat-checkbox (change)="areAllSitesSelected($event)" [(ngModel)]="allSelected"></mat-checkbox>
        </th>
        <th>SITE NAME</th>
        <th>SITE ADDRESS</th>
        <th>PERMISSION</th>
      </tr>
    </thead>
  </table>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-body" style="min-height: 500px">
    <table>
      <colgroup>
        <col width="5%"/>
        <col width="25%"/>
        <col width="40%"/>
        <col width="10%"/>
        <col width="5%"/>
      </colgroup>
      <tbody>
        <tr *ngIf="!hasReadAppUsersPermission" style="text-align: center; color: #999;">
          <td colspan="11">No Permission</td>
        </tr>
        <tr *ngIf="pagedItems?.length === 0" style="text-align: center; color: #999;">
          <td colspan="11">No Site</td>
        </tr>
        <tr class="has-child" *ngFor="let site of pagedItems">
          <td style="overflow-y: hidden">
            <mat-checkbox [(ngModel)]="site.isSelected" (change)="checkIsSitesSelected($event)"></mat-checkbox>
          </td>
          <td>{{site.name}}</td>
          <td>{{site.address1}} {{site.address2}}</td>
          <td><span class="member-role-badge">{{memberRoles[site.role]?.name}}</span></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="pagination-area" style="position: absolute; bottom: 0">
    <div style="font-size:12px; margin-right: auto;">{{selectedSites.length}} sites selected</div>
    <div class="space"></div>
    <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
      <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
      <div>of </div>
      <div>{{totalSite}}</div>
    </div>
    <div class="pagination">
      <div class="page-mover">
        <div class="btn-area">
          <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
            <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
          </div>
        </div>
        <div class="btn-area">
          <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
            <div class="btn-inner"><span>Next</span>
              <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>